module.exports = __webpack_public_path__ + "static/media/2072704..9f2946b6.pdf";